module.exports = __webpack_public_path__ + "static/media/coinGold.421e1f05.svg";